import DiagramBox from './diagram-box';
export default DiagramBox;
